import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { Location } from 'react-router';
import triggerGoogleTagManagerCustomEvent from '../../common/utils/triggerGoogleTagManagerCustomEvent';

/**
 * Shape of the JSON payload set in the `ps_mc_ud` cookie by the backend.
 * @see backend/app/code/Mel/Gtm/Service/TrackingDataGenerator.php
 */
type PsMcUdPayload = {
  company_id_sha256: string;
  user_id_sha256: string;
  user_email_normalized_sha256: string;
  user_email_normalized_google_sha256: string;
  user_phone_normalized_sha256: string | null;
};

export default function usePsInitUserEvent(location: Location) {
  useEffect(() => {
    const psMcUd = Cookies.get('ps_mc_ud');
    if (!psMcUd) {
      return;
    }
    try {
      const parsedData: unknown = JSON.parse(atob(psMcUd));
      if (typeof parsedData !== 'object' || parsedData === null) {
        return;
      }
      triggerGoogleTagManagerCustomEvent('ps_init_user', parsedData as PsMcUdPayload);
    } catch {
      return;
    }
  }, [location]);
}
